import React, { useState, useEffect, useContext } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import type { Address, Utilities } from "../../../types";
import qs from "qs";
import { fetchAddress, fetchUtility } from "../../../fetch/fetch";
import { Dropdown } from "react-bootstrap";
import { EnrollmentContext } from "./enrollment";
import { useLocation } from "react-router-dom";
import { FormError } from "../../FormError";

export const ValidateAddress = ({
  hide,
  errorFields,
}: {
  hide?: boolean;
  errorFields: any;
}) => {
  const [searching, setSearching] = useState(false);
  const [addressOptions, setAddressOptions] = useState<Address[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<Address[]>([]);
  const [loadingUtility, setLoadingUtility] = useState(false);
  const [utility, setUtility] = useState<Utilities[]>([]);
  const [selectedUtility, setSelectedUtility] = useState<Utilities | undefined>(
    undefined
  );
  const { changeServiceAddress, changeUtility, loading, serviceAddress } =
    useContext<any>(EnrollmentContext);
  const location = useLocation();
  const { utility_code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  // useEffect(() => {
  //     if (serviceAddress) {
  //         setSelectedAddress(serviceAddress);
  //     }

  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  useEffect(() => {
    if (selectedAddress.length === 0) return;
    setLoadingUtility(true);
    localStorage.setItem("selectedAddress", JSON.stringify(selectedAddress[0]));
    const { zipcode } = selectedAddress[0];
    fetchUtility(zipcode).then((res) => {
      setLoadingUtility(false);
      if (res) {
        setUtility(res);

        let idx = 0;
        if (utility_code) {
          for (let i in res) {
            if (
              res[i].utility_code.toLowerCase() ===
              `${utility_code}`.toLowerCase()
            ) {
              idx = parseInt(i);
              break;
            }
          }
        }
        setSelectedUtility(res[idx]);
        changeUtility(res[idx]);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress]);

  const handleSearch = (val: string) => {
    setSearching(true);
    fetchAddress(val).then((data) => {
      setAddressOptions(data);
      setSearching(false);
    });
  };

  const chooseUtility = () => {
    if (utility.length <= 1 || !selectedUtility) return null;
    if (utility_code) {
      const filterUtility = utility.filter(
        (val: any) =>
          val.utility_code.toLowerCase() === `${utility_code}`.toLowerCase()
      );
      if (filterUtility.length > 0) return null;
    }
    return (
      <Dropdown className="utility-select">
        <Dropdown.Toggle variant="light">
          {selectedUtility.utility_name}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {utility.map((val, idx) => (
            <Dropdown.Item
              eventKey={idx}
              key={idx}
              onClick={() => {
                setSelectedUtility(val);
                changeUtility(val);
              }}
              active={val.utility_id === selectedUtility.utility_id}
            >
              {val.utility_name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <div className={`autocomplete-address-row ${hide ? "hide" : ""}`}>
      <div
        id="autocomplete-wrapper"
        className={errorFields["service_address"] ? "error" : ""}
      >
        <AsyncTypeahead
          filterBy={() => true}
          id="autocomplete"
          isLoading={searching}
          labelKey="label"
          minLength={1}
          onSearch={handleSearch}
          options={addressOptions}
          placeholder="Address..."
          size="lg"
          onChange={(val) => {
            setSelectedAddress(val);
            changeServiceAddress(val);
            // changeUtility(undefined);
          }}
          selected={
            selectedAddress.length > 0
              ? selectedAddress
              : serviceAddress.length > 0
              ? serviceAddress
              : []
          }
          disabled={loading}
        />
      </div>
      <FormError message={errorFields["service_address"]} />
      {chooseUtility()}
    </div>
  );
};
